module.exports = __webpack_public_path__ + "static/media/caregiver-thumbnail.57796ac1.png";